/**
 * Camada 0 · a identidade do LU BARROS STUDIO.
 *
 * DIVERGENCIA LOCAL DO STUDIOLU (ver packages/ORIGEM.md): na plataforma este arquivo guarda a
 * identidade da Complexity. Aqui ele guarda a do Lu Barros Studio, com os MESMOS nomes de
 * constante, porque `TelaLogin.tsx` e `Rail.tsx` importam `NOME_PARTES`, `NOME_CURTO_PARTES`,
 * `DOMINIO` e `Simbolo` por esses nomes. Mudar o valor e nao o nome e o que deixa o Chassi
 * copiado sem uma linha alterada.
 *
 * O QUE MORA AQUI, e o criterio e uma linha: dado da MARCA. Nome, iniciais, tagline, dominio.
 * Marca de PRODUTO (o titulo "Painel administrativo", o menu) continua vindo do manifesto em
 * `packages/catalogo`, e nao daqui.
 *
 * CAMADA 0: nao importa nada, nem outros pacotes da camada 0. Identidade e o chao.
 *
 * DE ONDE VEM CADA VALOR, medido em 19/09/2026 no legado que esta no ar:
 *   · nome ............ `portal/admin.html:1712`, o eyebrow "Lu Barros Studio" acima do titulo
 *   · tagline ......... `site/index.html:9`, o <title> do site publicado
 *   · dominio ......... studiolu.com.br, o endereco do site (CLAUDE.md do projeto)
 */

/** O nome como a pessoa le, em toda superficie publica. */
export const NOME = 'Lu Barros Studio';

/**
 * O nome por extenso, como o site o escreve no <title> antes do ponto medio.
 *
 * Ele e igual ao `NOME` aqui, e a igualdade e medida e nao preguica: o site publicado nao usa
 * forma mais longa do nome, so acrescenta a tagline depois do separador.
 */
export const NOME_EXTENSO = 'Lu Barros Studio';

/**
 * A divisao do nome em duas partes, com a segunda na cor da marca.
 *
 * O Chassi escreve `primeira <span class="text-marca">destaque</span>` no pe da tela de entrada
 * e na assinatura do menu. "Studio" como destaque segue o logotipo, onde o nome da pessoa e o
 * que o monograma carrega e o "Studio" e o complemento.
 */
export const NOME_PARTES = {
  primeira: 'Lu Barros',
  destaque: 'Studio',
} as const;

/**
 * A forma CURTA do nome, usada pelo Chassi SO na linha "Desenvolvido por" da tela de entrada
 * (`packages/auth/src/components/TelaLogin.tsx:843`).
 *
 * Aquela linha afirma AUTORIA. Decisao do fundador em 19/09/2026: "Desenvolvido por ComplexityDS
 * (com link para complexityds.com.br)", no lugar do "Desenvolvido por Destravads" do admin atual
 * (`portal/admin.html:2835`). Os valores sao os mesmos da plataforma.
 */
export const NOME_CURTO = 'ComplexityDS';

/**
 * A divisao da forma curta. O Chassi cola as duas partes SEM espaco
 * (`{primeira}<span>{sigla}</span>`) e pinta a sigla na cor da marca, como na plataforma.
 */
export const NOME_CURTO_PARTES = {
  primeira: 'Complexity',
  sigla: 'DS',
} as const;

/**
 * Para onde o nome da linha "Desenvolvido por" leva, em nova aba. Pedido do fundador em
 * 19/09/2026. Mora aqui, e nao escrito na tela, porque e dado da marca.
 */
export const URL_AUTORIA = 'https://complexityds.com.br';

/**
 * As iniciais da marca, as mesmas duas letras do monograma do favicon (`portal/admin.html:17`).
 *
 * O manifesto de cada produto repete o valor no campo `iniciais`, que e o contrato do
 * `ProductConfig`; este e o valor da MARCA, para quem precisar dele fora de um produto.
 */
export const INICIAIS = 'LB';

/**
 * A razao social.
 *
 * VAZIO ATE ALGUEM PREENCHER, e vazio de proposito: inventar uma razao social produz um texto
 * que nao existe em cartorio nenhum e o apresenta como se fosse o registro.
 */
export const NOME_LEGAL = '';

/** A tagline, como esta no `<title>` do site publicado (`site/index.html:9`). */
export const TAGLINE = 'Estratégia de Imagem Pessoal & Profissional';

/**
 * O DOMINIO RAIZ da marca, o do site institucional.
 *
 * Mora aqui, e nao em variavel de ambiente, porque e o endereco publico da marca, um so, igual
 * em toda superficie e em todo ambiente.
 */
export const DOMINIO = 'studiolu.com.br';

/**
 * As URLs oficiais, derivadas do dominio acima e medidas no que esta no ar hoje.
 *
 * O portal da cliente e o painel administrativo moram no MESMO endereco (`portal.`), o admin
 * na pagina `admin.html`: e assim que o legado publica, e e o que a pessoa tem salvo.
 * `suporte` continua VAZIA porque nao existe; um endereco chutado viraria link quebrado.
 */
export const URLS = {
  site: `https://${DOMINIO}`,
  app: `https://portal.${DOMINIO}`,
  admin: `https://portal.${DOMINIO}/admin.html`,
  suporte: '',
} as const;

/** O tipo da marca, para quem consome. */
export interface Marca {
  readonly nome: string;
  readonly nomeExtenso: string;
  readonly nomeLegal: string;
  readonly tagline: string;
}

export const MARCA: Marca = {
  nome: NOME,
  nomeExtenso: NOME_EXTENSO,
  nomeLegal: NOME_LEGAL,
  tagline: TAGLINE,
};
